import { render, staticRenderFns } from "./luckyredpacket.vue?vue&type=template&id=6c44fb5c"
import script from "./luckyredpacket.vue?vue&type=script&lang=js"
export * from "./luckyredpacket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports